import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import printJS from "lib/print-js";
import { CommunicationLogReplacementCar } from "modules/AppointmentDetails/components/CommunicationLogReplacementCar";
import { AppointmentDetails, Communications } from "modules/AppointmentDetails/components/KioskCommunicationLog/components";
import "modules/AppointmentDetails/components/KioskCommunicationLog/components/CommunicationLogs/CommunicationLogs.scss";

import type { Appointment } from "models";

type CommunicationLogsProps = {
  appointment: Appointment;
  isModalOpen: boolean;
  defaultTabActiveIndex?: number;
  onToggleIsModalOpen: (evt: React.MouseEvent) => void;
};

export const CommunicationLogs = ({ appointment, isModalOpen, defaultTabActiveIndex = 0, onToggleIsModalOpen }: CommunicationLogsProps) => {
  const { t } = useTranslation();

  if (!appointment.kiosk_communications) return null;

  const handlePrint = () =>
    printJS({
      printable: "CommunicationLogs-Content",
      type: "html",
      copyStyles: true,
      css: ["./CommunicationLogs.css"],
      scanStyles: false,
      targetStyles: ["*"]
    });

  return (
    <Modal open={isModalOpen} className="CommunicationLogs">
      <Modal.Header className="CommunicationLogsHeader">
        <div className="header-title">
          <Icon name="list" />
          <div>{t("v8_kiosk_comm_log", "Kiosk Communication Log")}</div>
        </div>

        <div className="modal-header-actions">
          <Button onClick={handlePrint} className="modal-print-btn" color="grey">
            {t("v8_print", "Print")}
            <Icon className="print" />
          </Button>

          <Button className="modal-close-btn" basic onClick={onToggleIsModalOpen}>
            <Icon className="xmark" />
          </Button>
        </div>
      </Modal.Header>

      <Modal.Content id="CommunicationLogs-Content" scrolling>
        <AppointmentDetails appointment={appointment} />
        <CommunicationLogReplacementCar appointment={appointment} />

        <Communications kiosk_communications={appointment.kiosk_communications} defaultTabActiveIndex={defaultTabActiveIndex} />
      </Modal.Content>
    </Modal>
  );
};
